import React,{useState,useRef} from 'react'
import { getPayfortUrl } from '../../actions/PayfortAction'
import { salesforceSendFormNumber } from '../../actions/StudentAction'


const AmazonPay = ({paymentConfig,userDetail,selectedMethodFeeDetail,feeDetail}) => {
  const {id,form_num} = userDetail !==undefined && userDetail
  const {installment_type,net_payable_amount,scholarship_amount,scholarship_percentage,total_fee} = feeDetail !==undefined && feeDetail
  const formRef = useRef(null);
    const {instData} = selectedMethodFeeDetail
    const [loading,setLoading] = useState(false)
    const [formStateData,setFormStateData] = useState();
  const {requestParams} = formStateData !==undefined && formStateData

    const AmazonButtonHandle = () => {
      setLoading(true)
      const data = {
        student_id: id,
        amount:parseFloat(instData?.amount).toFixed(2) ,
        gateway_id: paymentConfig.id,
        success_url:`${process.env.REACT_APP_PUBLIC_URL}/student/paymentstatus/success`,
        failure_url:`${process.env.REACT_APP_PUBLIC_URL}/student/paymentstatus/failure`,
        scholarship_amount:scholarship_amount,
        net_payable_amount:net_payable_amount,
        installments_id:instData?.installment_id,
        installment_type:instData?.installment_number ==0 ? "lumpsum" :installment_type,
        scholarship_percentage:scholarship_percentage,
        actual_inst_amt:parseFloat(instData?.amount).toFixed(2),
        course_fee:total_fee,
        installments_number:instData?.installment_number
      }


      getPayfortUrl(data).then((res) => {
          setLoading(true)
         
          if(res.status){
              setLoading(false)
              salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
              setFormStateData(res)
            }
      })

      

  }

  if (formStateData !==undefined) {
    setTimeout(() => { formRef.current.submit(); }, 1000)
  }

  return (
    <div>
    {loading ? <button type="submit" disabled className="banktransfer_btn">
            <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
            Processing ...</button> : 
            <>
       <button onClick={AmazonButtonHandle}
       className='banktransfer_btn'>Amazon payment services</button>

    </>
    }

              {formStateData &&  
              <form ref={formRef}
                    method="POST"
                    name="redirect"
                    action={`${formStateData?.url}`}
                    >
                    
                   {Object.keys(requestParams !==undefined && requestParams).map((key, index) => (
                      <input
                        key={index}
                        type="hidden"
                        name={key}
                        value={requestParams[key]}
                        readOnly
                      />
                    ))}
                </form>
                }
    </div>
  )
}

export default AmazonPay